import { ApiHttpService } from '../ApiHttpService';
import { SuggestionSerializer } from '../serializers/SuggestionSerializer';
import { Suggestion } from '../../models/Suggestion';
import { ParamsHelper } from '../../helpers/ParamsHelper';

const SUGGESTION_PATH = 'articulos/ObtenerSugerenciaBusqueda/';

class SuggestionsController {
  static async suggest(query, queryFilter) {
    const params = ParamsHelper.createQueryParams({
      sugerir: query,
      filtroBusquedaIntra: queryFilter,
    });
    const { data } = await ApiHttpService.get(`${SUGGESTION_PATH}${params}`);
    const deSerializedSuggestions = (data || []).map(SuggestionSerializer.deSerialize);
    return deSerializedSuggestions.map(suggestion => new Suggestion(suggestion));
  }
}

export { SuggestionsController };



// WEBPACK FOOTER //
// ./src/networking/controllers/SuggestionsController.js